import { post } from './utils';

const footprintCalculate = async params => post('/footprint-calculator/calculate', params);

export const footprintCalculator = { footprintCalculate };
